import {
  Ruler, Compass, Mountain, Map, HardHat, Building, Waves, Route, Satellite,
  LayoutDashboard, Box, Building2, Construction, Cog, Zap, Layers3, Droplets,
  Fan, TrafficCone, Aperture, FileInput, Sun, Signpost, MapPinned, Layers, Shapes,
} from "lucide-react";

const SURVEY_ICONS = { Ruler, Compass, Mountain, Map, HardHat, Building, Waves, Route, Satellite, LayoutDashboard, Box };

const CAD_ICONS = {
  "architectural-cad": Building2,
  "structural-cad": Construction,
  "mechanical-cad": Cog,
  "electrical-cad": Zap,
  "mep-bim": Layers3,
  "plumbing-piping": Droplets,
  "hvac-cad": Fan,
  "civil-engineering-drafting": TrafficCone,
  "3d-rendering": Aperture,
  "pdf-to-cad": FileInput,
  "solar-pv-design": Sun,
  "signage-design": Signpost,
};

export const CATEGORY_ICONS = {
  "Boundary & Title": MapPinned,
  "Topographic & Mapping": Layers,
  "Construction & Modeling": HardHat,
  "Architecture & Structural": Building2,
  "MEP, Mechanical & Electrical": Cog,
  "Civil, Conversion & Specialty": Shapes,
};

export const surveyIcon = (s) => SURVEY_ICONS[s.icon] || Compass;
export const cadIcon = (s) => CAD_ICONS[s.slug] || Box;
